import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { affiliatorRegisterForm } from '../../Action/registration';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { Footer, LoginHeader } from '../Common';
import BuyerUser from '../../Models/BuyerUser';
class AffiliatorRegistrationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            email: '',
            username: '',
            password: '',
            refcode: '',
            status: '',
            termCondition: '',
            errors: [],

        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
        var link = window.location.pathname;
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        let x = JSON.parse(localStorage.getItem('info'));
        if (x !== null && x !== '' && x.user_type_id === 1) {
            alert('');
            window.location.href = '/buyer-dashboard';
        } else if (x !== null && x !== '' && x.user_type_id === 2) {
            window.location.href = '/seller-dashboard';
        } else if (x !== null && x !== '' && x.user_type_id === 3) {
            window.location.href = '/affiliator-dashboard';
        }
    }
    componentWillMount() {
        let url = window.location.pathname.split('/');
        let id = url[url.length - 1]
        console.log(id)
        this.setState({ refCode: id })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            console.log(nextProps.errors)
            this.setState({ errors: nextProps.errors })
            console.log('ads', this.state.errors);
        }
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }


    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            if (this.state.termCondition === true) {
                let data = {}
                data = {
                    email: this.state.email,
                    name: this.state.username,
                    password: this.state.password,
                    ref_code: this.state.refCode

                }
                console.log(data)
                this.props.affiliatorRegisterForm(data, this.props.history);
            } else {
                alert('利用契約に同意してください。')
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    checkValue(a) {
        this.validator.showMessageFor(a)
        // let data = {
        let name = this.state.username
        // }
        BuyerUser.getUserName(name, 0).then(res => {
            // console.log(res.data)
            if (res.data.status === 200) {
                alert('このユーザー名は既に利用されています')
                this.state.username = ''
                this.setState({ status: res.data.status })
            } else {
                this.state.username = this.state.username
            }
        })
    }
    userName() {

        const isMobile = window.innerWidth <= 500;
        if(isMobile){
            if (this.state.status === 200) {
                return (
                    <div className="row col-md-12">
                        <div className="field_names"style={{ width: '50%', textAlign: 'left' }}> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required ')}</span>
                    </div>
                )
            } else {
                return (
                    <div className="row col-md-12">
                        <div className="field_names"style={{ width: '50%', textAlign: 'left' }}> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" value={this.state.username} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required')}</span>
                    </div>
                )
            }
        }else {

            if (this.state.status === 200) {
                return (
                    <div className="row">
                        <div className="field_names"> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required ')}</span>
                    </div>
                )
            } else {
                return (
                    <div className="row">
                        <div className="field_names"> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" value={this.state.username} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required')}</span>
                    </div>
                )
            }
        }
    }
    render() {
        const { errors } = this.state.errors

        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 mb-2 " >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="row mt-5 ">
                                <div className="col-md-12 tr_blank_big ">
                                    <div className="">

                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 form-group">
                                            <form onSubmit={this.handleSubmit.bind(this)}>

                                                <div className="mb-2 ml-5 pl-5" style={{ color: "red" }} >{errors}</div>
                                                <div className="reg_first"><b>新規アフィリエイター登録</b></div>
                                                <div className="dots">
                                                    <hr />
                                                </div>
                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%', textAlign: 'left' }}> メールアドレス</div>
                                                    <div className="blank_line"></div>
                                                    <div><input className="input_box" placeholder="メールIDを入力してください" value={this.state.email} onChange={this.updateValue.bind(this, "email")} /></div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('メールアドレス', this.state.email, 'required')}</span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {this.userName()}

                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%', textAlign: 'left' }}> パスワード</div>
                                                    <div className="blank_line"></div>
                                                    <div><input type="password" className="input_box" placeholder="パスワードを入力してください" value={this.state.password} onChange={this.updateValue.bind(this, "password")} /></div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span>
                                                </div>

                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%', textAlign: 'left' }}> Referralコード</div>
                                                    <div className="blank_line"></div>
                                                    <div><input type="text" className="input_box" placeholder="Refaral Code" value={this.state.refCode} /></div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="blank_line"style={{width:'17%'}}></div>
                                                    <div className="blank_line"></div>
                                                    <div style={{marginTop:'2px'}}>
                                                        <input type="checkbox" className="" placeholder="パスワードを入力してください" value={this.state.termCondition} onChange={this.updateValue.bind(this, "termCondition")} />
                                                    </div>
                                                    <div className="field_names" style={{ paddingTop: '3px', width: '30%', textAlign: 'center' }}> <Link to={'/terms-conditions'} target="_blank">利用規約</Link>に同意する</div>


                                                    {/* <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span> */}
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    <div className="remember_text " style={{ paddingLeft: '65px' }}>
                                                        {/* <Link to={"/registration-success-message"}> */}
                                                        <button type="submit" className="agree_button ml-5 " style={{ width: '100%' }}>登録する</button>
                                                        {/* </Link> */}
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="col-md-3">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5" >
                        <div className=" mt-5">
                            <Footer />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 mb-2 " >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="row mt-5 ">
                                <div className="col-md-12 tr_blank_big ">
                                    <div className="">

                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 form-group">
                                            <form onSubmit={this.handleSubmit.bind(this)}>

                                                <div className="mb-2 ml-5 pl-5" style={{ color: "red" }} >{errors}</div>
                                                <div className="reg_first"><b>新規アフィリエイター登録</b></div>
                                                <div className="dots">
                                                    <hr />
                                                </div>
                                                <div className="row ">
                                                    <div className="field_names"> メールアドレス</div>
                                                    <div className="blank_line"></div>
                                                    <div><input className="input_box" placeholder="メールIDを入力してください" value={this.state.email} onChange={this.updateValue.bind(this, "email")} /></div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('メールアドレス', this.state.email, 'required')}</span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {this.userName()}

                                                <div><div>&nbsp;</div></div>
                                                <div className="row ">
                                                    <div className="field_names"> パスワード</div>
                                                    <div className="blank_line"></div>
                                                    <div><input type="password" className="input_box" placeholder="パスワードを入力してください" value={this.state.password} onChange={this.updateValue.bind(this, "password")} /></div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span>
                                                </div>

                                                <div><div>&nbsp;</div></div>
                                                <div className="row ">
                                                    <div className="field_names"> Referralコード</div>
                                                    <div className="blank_line"></div>
                                                    <div><input type="text" className="input_box" placeholder="Refaral Code" value={this.state.refCode} /></div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div className="field_names"></div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="checkbox" className="" placeholder="パスワードを入力してください" value={this.state.termCondition} onChange={this.updateValue.bind(this, "termCondition")} />
                                                    </div>
                                                    <div className="field_names" style={{ paddingTop: '3px', width: '30%', textAlign: 'center' }}> <Link to={'/terms-conditions'} target="_blank">利用規約</Link>に同意する</div>


                                                    {/* <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span> */}
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div></div>
                                                    <div className="blank_line"></div>
                                                    <div className="remember_text ml-5 pl-4" style={{ paddingLeft: '65px' }}>
                                                        {/* <Link to={"/registration-success-message"}> */}
                                                        <button type="submit" className="agree_button ml-5 " style={{ width: '100%' }}>登録する</button>
                                                        {/* </Link> */}
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="col-md-3">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5" >
                        <div className=" mt-5">
                            <Footer />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    affiliatorRegisterForm: state.affiliatorRegisterForm,
    errors: state.errors,
});

AffiliatorRegistrationForm = connect(mapStateToProps, { affiliatorRegisterForm })(withRouter(AffiliatorRegistrationForm));
export { AffiliatorRegistrationForm };